import { baseRequest } from '../common/request.js';
export const buildProductEnrichmentBadgesRequest = (req) => {
    return {
        ...baseRequest(req, 'badges'),
        requestParams: prepareProductEnrichmentRequestParams(req),
    };
};
const prepareProductEnrichmentRequestParams = (req) => {
    const { language, country, currency, placementIds, context, clientId } = req;
    return {
        language,
        country,
        currency,
        placementIds,
        context,
        ...(clientId && { clientId }),
    };
};
